import { render, staticRenderFns } from "./orderBanner.vue?vue&type=template&id=124dd60c&"
import script from "./orderBanner.vue?vue&type=script&lang=js&"
export * from "./orderBanner.vue?vue&type=script&lang=js&"
import style0 from "./orderBanner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports